import { Typography } from '@mui/material'
import { DEAL_STATUS } from '@constants/data'
import { makeOfferPeriod } from '@utils/dataHelper'
import './StatusBadge.scss'

const StatusBadge = ({ status, hoursLeft }) => {
  return (
    <>
      <Typography
        variant="span"
        className={`badge ${DEAL_STATUS[status].toLowerCase().replace(/ /g, '-')}`}
      >
        {DEAL_STATUS[status]}
      </Typography>
      {status === 2 && hoursLeft > 0 && (
        <Typography
          variant="span"
          className="text-red"
          sx={{ ml: 1 }}
        >
          {makeOfferPeriod(hoursLeft)} Left
        </Typography>
      )}
    </>
  )
}

export default StatusBadge